import "core-js/stable";
import cssVars from 'css-vars-ponyfill';
import '../scss/screen.scss';
import 'element-closest-polyfill';
import { polyfill as smoothscroll } from 'smoothscroll-polyfill';
import "picturefill-background";
import objectFitImages from "object-fit-images";

import DonationBlock from './components/DonationBlock';
import Modal from './components/Modal';
import DonationForm from './components/DonationForm';
import Reveal from './components/Reveal';
import MessageBox from './components/MessageBox';
import FormValidate from './components/FormValidate';
import AddressFinder from './components/AddressFinder';
import CarouselMobile from './components/CarouselMobile';
import IconTabCarousel from './components/IconTabCarousel';
import AdditionalEvents from './components/AdditionalEvents';
import ReadMoreMobile from './components/ReadMoreMobile';
import ScrollingNavBar from './components/ScrollingNavBar';

declare global {
    interface Window {
        grecaptcha: any,
        dataLayer: any
    }
}

document.addEventListener('DOMContentLoaded', () => {
    cssVars();
    smoothscroll();
    objectFitImages();

    const donationBlock = new DonationBlock();
    donationBlock.init();

    const modal = new Modal();
    modal.init();

    DonationForm.init();

    const reveal = new Reveal();
    reveal.init();

    const messageBox = new MessageBox();
    messageBox.init();

    const formValidate = new FormValidate();
    formValidate.init();

    const addressFinder = new AddressFinder();
    addressFinder.init();

    const carouselMobile = new CarouselMobile();
    carouselMobile.init();

    const iconTabCarousel = new IconTabCarousel();
    iconTabCarousel.init();

    const additionalEvents = new AdditionalEvents();
    additionalEvents.init();

    const readMoreMobile = new ReadMoreMobile();
    readMoreMobile.init();

    const scrollingNavBar = new ScrollingNavBar();
    scrollingNavBar.init();

    // To programmatically show/hide the modal:
    // modal.show('<id>');
    // modal.hide('<id>');
});